module.exports = __webpack_public_path__ + "img/site-logo.bb0d679a.svg";